import SalesInsightPage from "../components/pages/salesInsight/SalesInsightPage";

const routes = [
    {
        path: "/sales-insight",
        element: <SalesInsightPage />
    }
];

export default routes;
